import React from 'react';

const CabeceraCliente = ({ cotizacion }) => {
    return (
        <div className="grid mb-3">
            <div className="col-12 md:col-6">
                <div className="flex flex-column gap-1">
                    <div className="flex">
                        <span className="text-500 font-medium mr-2">Código</span>
                        <span className="text-900">{cotizacion?.cliente?.codigo || ''}</span>
                    </div>
                    <div className="flex">
                        <span className="text-500 font-medium mr-2">Razón Social</span>
                        <span className="text-900">{cotizacion?.cliente?.razonSocial || ''}</span>
                    </div>
                    <div className="flex">
                        <span className="text-500 font-medium mr-2">Lista Precios</span>
                        <span className="text-900">{cotizacion?.listaPrecio?.descripcion || ''}</span>
                    </div>
                    <div className="flex">
                        <span className="text-500 font-medium mr-2">Condición de Pago</span>
                        <span className="text-900">{cotizacion?.condicion?.descripcion || ''}</span>
                    </div>
                    <div className="flex">
                        <span className="text-500 font-medium mr-2">Obras</span>
                        <span className="text-900">{cotizacion?.obra?.descripcion || ''}</span>
                    </div>
                    <div className="flex">
                        <span className="text-500 font-medium mr-2">Fecha Decisión</span>
                        <span className="text-900">{cotizacion?.decision || ''}</span>
                    </div>
                </div>
            </div>
            <div className="col-12 md:col-6">
                <div className="flex flex-column gap-1">
                    <div className="flex">
                        <span className="text-500 font-medium mr-2">RUT</span>
                        <span className="text-900">{cotizacion?.cliente?.rut || ''}</span>
                    </div>
                    <div className="flex">
                        <span className="text-500 font-medium mr-2">Contacto</span>
                        <span className="text-900">{cotizacion?.cliente?.contacto?.nombre || ''}</span>
                    </div>
                    <div className="flex">
                        <span className="text-500 font-medium mr-2">Vendedor</span>
                        <span className="text-900">{cotizacion?.cliente?.vendedor?.descripcion || ''}</span>
                    </div>
                    <div className="flex">
                        <span className="text-500 font-medium mr-2">Zona</span>
                        <span className="text-900">{cotizacion?.zona?.descripcion || ''}</span>
                    </div>
                    <div className="flex">
                        <span className="text-500 font-medium mr-2">Condiciones de Entrega</span>
                        <span className="text-900">{cotizacion?.condicion?.descripcion || ''}</span>
                    </div>
                    <div className="flex">
                        <span className="text-500 font-medium mr-2">Validez</span>
                        <span className="text-900">{cotizacion?.validez?.descripcion || ''}</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CabeceraCliente;
